export const MIN_PASSWORD_LENGTH = 12;

/**
 * Regular expression pattern to validate a password.
 * The password must:
 * - Be at least 12 characters long
 * - Contain at least one digit
 * - Contain at least one lowercase letter
 * - Contain at least one uppercase letter
 * - Contain at least one non-alphanumeric character (including whitespace)
 *
 * @type {RegExp}
 */
export const PASSWORD_REGEX: RegExp =
    /^(?=.*[0-9])(?=.*[a-z])(?=.*[A-Z])(?=.*[^a-zA-Z0-9\s]).{12,}$/;

export const PASSWORD_CHECKS: Record<string, string> = {
    oneLowerCase: 'one lowercase character',
    oneUpperCase: 'one uppercase character',
    oneNumber: 'one number',
    oneSpecial: 'one special character',
    minChar: `${MIN_PASSWORD_LENGTH} character minimum`,
};

// validate the password and returns the boolean value for each case.
export const validatePassword = (str: string): Record<string, boolean> => {
    return {
        oneLowerCase: /[a-z]/.test(str),
        oneUpperCase: /[A-Z]/.test(str),
        oneNumber: /[0-9]/.test(str),
        oneSpecial: /[^a-zA-Z0-9\s]/.test(str),
        minChar: str.length >= MIN_PASSWORD_LENGTH,
    };
};
